import { EmphasisText } from "../EmphasisText";
import { OnboardingIllustration } from "../OnboardingIllustration";
import { OnboardingVibesOverlay } from "../OnboardingVibesOverlay";
import { getOnboardingIllustrationDimensions } from "../onboardingImagePreload";
import { onboardingImageCandidates } from "../onboardingImageUrl";

type NarrativeSlideProps = {
  imageStep: 1 | 2 | 3 | 4;
  imageAlt: string;
  paragraphs: readonly string[];
};

export function NarrativeSlide({ imageStep, imageAlt, paragraphs }: NarrativeSlideProps) {
  const dimensions = getOnboardingIllustrationDimensions(imageStep);

  return (
    <div className="flex flex-1 flex-col items-center gap-6 pb-4">
      <div className="relative mx-auto w-fit max-w-[280px]">
        <OnboardingVibesOverlay variant={imageStep} />
        <OnboardingIllustration
          candidates={onboardingImageCandidates(imageStep)}
          alt={imageAlt}
          intrinsicWidth={dimensions?.width}
          intrinsicHeight={dimensions?.height}
        />
      </div>

      <div className="flex w-full max-w-md flex-col gap-4 text-center text-[oklch(82%_0.025_155)]">
        {paragraphs.map((paragraph, index) => (
          <p
            key={index}
            className={index === 0 ? "text-lg leading-7" : "text-base leading-7"}
          >
            <EmphasisText text={paragraph} />
          </p>
        ))}
      </div>
    </div>
  );
}
